<template>
  <div class="saved-address-container">
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />
    
    <div class="d-flex align-center justify-space-between mb-8">
      <div class="d-flex align-center">
        <v-icon color="#3EA56E" class="mr-3">mdi-map-marker-multiple-outline</v-icon>
        <h2 class="section-title">Saved Addresses</h2>
      </div>
    </div>

    <v-layout wrap v-if="address && address.length > 0">
      <v-flex
        xs12
        sm6
        md6
        lg6
        class="pa-2"
        v-for="(item, i) in address"
        :key="i"
      >
        <Address
          v-bind:storage="item"
          v-bind:defaultAddress="defaultAddress"
          @stepper="winStepper"
          :key="item._id"
        />
      </v-flex>
    </v-layout>
    
    <div v-else-if="!appLoading" class="text-center py-12">
      <v-icon size="64" color="#e2e8f0" class="mb-4">mdi-map-marker-off-outline</v-icon>
      <p class="empty-text">No saved addresses found.</p>
    </div>
  </div>
</template>

<script>
import Address from "./savedAddressItem";
import axios from "axios";
export default {
  components: {
    Address,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      ServerError: false,
      msg: null,
      address: [],
      radios: null,
      defaultAddress: {},
    };
  },
  mounted() {
    this.setMetaTags();
    this.getProfile();
  },
  methods: {
    setMetaTags() {
      document.title = "Saved Addresses | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "Manage your delivery addresses for quick and easy checkout at KL-06 FARM.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.address = response.data.data.deliveryaddress;
            this.radios = response.data.data.deliveryaddressindex;
            localStorage.setItem("address", response.data.data.deliveryaddressindex);

            for (var i = 0; i < this.address.length; i++) {
              if (
                response.data.data.deliveryaddressindex == this.address[i]._id
              ) {
                this.defaultAddress = this.address[i];
              }
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error("Error fetching addresses:", err);
        });
    }, 
    winStepper(item) {
      if (item.ref == "DefaultAddressItem") {
        this.setDefaultAddress(item.address);
      }
    },
    setDefaultAddress(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          deliveryaddressindex: item._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Shipping Address Changed";
            this.showSnackBar = true;
            this.getProfile();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error("Error setting default address:", err);
        });
    },
  },
};
</script>

<style scoped>
.saved-address-container {
  text-align: left;
}

.section-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 20px;
  color: #1a202c;
  margin: 0;
}

.empty-text {
  font-family: "sofialight", sans-serif;
  font-size: 16px;
  color: #64748b;
}

@media (max-width: 600px) {
  .section-title {
    font-size: 18px;
  }
}
</style>